// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__ksdPG","icon":"Alert_icon__2LfSZ","info":"Alert_info__FlwOl","success":"Alert_success__mnk2E","warning":"Alert_warning__+7XbV","error":"Alert_error__Kpr2k"};